/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Loading_ListsInputs */



/**
* | output |
* | --- |
* | "Loading lists..." |
*
* @param {Loading_ListsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const loading_lists = /** @type {((inputs?: Loading_ListsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loading_ListsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chargement des listes...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Lade Listen...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Caricamento elenchi in corso...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Загрузка списков...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cargando listas...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在加载列表...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("リストを読み込んでいます...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सूचियाँ लोड हो रही हैं...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Carregando listas...")
	return /** @type {LocalizedString} */ ("Loading lists...")
});